import { Component, NgZone } from '@angular/core';
import { DataProvider } from '../../providers/data/data'
import { Events } from 'ionic-angular';

@Component({
  selector: 'offline-banner',
  templateUrl: 'offline-banner.html'
})
export class OfflineBannerComponent {

  public offline: boolean;
  private offlinesub: any;
  public fadein: string = "";
  constructor(private events: Events, private zone: NgZone, private dataProvider: DataProvider) {
    
    this.offline = this.dataProvider.isOffline();

    this.offlinesub = this.events.subscribe("StatusChange:isConnected", () => {

      this.zone.run(() => {
        this.offline = this.dataProvider.isOffline();
        this.fadein = "fadein";
        setTimeout(() => {
          this.fadein = "";
        }, 2300)
      });
    });
  }

  ngOnDestroy() {
    if (typeof (this.offlinesub) != "undefined") {
      this.offlinesub.unsubscribe();
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/offline-banner/offline-banner.ts